export default "__VITE_ASSET__CkYO7yq5__"